import {ObjectFactory, TabellaGenerica} from "@commons/types";
import {URIAndTrace} from "@commons/mapping/URIAndTrace";
import {Giustificativi, TipoGiustificativo} from "@commons/mapping/Giustificativi";
import {CentroDiCostoRecord, ProfRetributivoRecord, ValoreGruppoRecord} from "@commons/mapping/CentroDiCostoRecord";
import {merge} from "lodash";
import {StatusGiustificativoRecord} from "@commons/mapping/StatusGiustificativoRecord";
import {PresenzeGiornataPlusRecord} from "@commons/mapping/PresenzeGiornataPlusRecord";
import {LavoratoreStatusRecord} from "@commons/mapping/LavoratoreStatusRecord";
import {GiustificativoAggancioRecord} from "@commons/mapping/GiustificativoAggancioRecord";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const thh_mancanti = "M";               // ore mancanti
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const thh_eccedentiDiurne = "E";        // ore eccedenti straordinarie diurne
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const thh_eccedentiNotturne = "N";      // ore eccedenti straordinarie notturne
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const thh_supplementariDiurne = "S";    // ore eccedenti supplementari diurne
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const thh_supplementariNotturne = "T";  // ore eccedenti supplementari notturne
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const thh_maggiorazione = "G";          // ore da maggiorare
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const thh_eccedentiNonStr = "X";        // ore eccedenti non straordinarie/supplementari
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const thh_evidenziate = "Z";            // ore evidenziate, nessuna correlazione con le timbrature

export enum ShowFlagsWF {
    None = 0,
    planning = 1 << 0,  // 0001 -- the bitshift is unnecessary, but done for consistency
    totali = 1 << 1,    // 0010
    All = ~(~0 << 4)    // 1111
}

export interface GruppoEventi {
    CDIC?: CentroDiCostoRecord[],
    GRUPPO_01?: ValoreGruppoRecord[],
    GRUPPO_02?: ValoreGruppoRecord[],
    GRUPPO_03?: ValoreGruppoRecord[],
    GRUPPO_04?: ValoreGruppoRecord[],
    GRUPPO_05?: ValoreGruppoRecord[],
    GRUPPO_06?: ValoreGruppoRecord[],
    GRUPPO_07?: ValoreGruppoRecord[],
    GRUPPO_08?: ValoreGruppoRecord[],
    GRUPPO_09?: ValoreGruppoRecord[],
    GRUPPO_10?: ValoreGruppoRecord[],
    GRUPPO_11?: ValoreGruppoRecord[],
    GRUPPO_12?: ValoreGruppoRecord[],
    PROF_RETRIBUTIVO?: ProfRetributivoRecord[],
    STATUS?: CentroDiCostoRecord[],
    MANSIONE?: CentroDiCostoRecord[],
}

export type IdTabellaGenericaAzienda = keyof GruppoEventi;

export interface GiustificativoRecord extends Giustificativi, URIAndTrace {
    idAzienda: number | null,
    /*
        codGiu: string | null,
        descrizione: string | null, // MAX 40 CHAR
        tipoAutomatismo: 0 | 1 | 2 | 3 | 5 | 6 | 7 | null,
        tipoGiu: 'O' | 'Q' | 'I' | 'E' | null,
        tipoOreGiu: 'M' | 'E' | 'N' | 'S' | 'T' | 'G' | 'X' | 'Z' | null,
    */

    applicaSu6: boolean,
    applicaSu7: boolean,
    applicaSuAltri: boolean,
    applicaSuFS: boolean,

    mancanteLavorato: boolean,
    stampaMancanteLavorato: boolean,
    decimaleMin: number,
    decimaleMultipliDi: number,
    idProfiloGiu: number | null,
    consenti0sePrev0: boolean,
    convertiQinHH: boolean,
    eccedenteRetribuito: boolean,
    idGruppoValori: IdTabellaGenericaAzienda | null,
    specificaValore: boolean,
    tipoCalcoloConvenzionale?: number, // NON UTILIZZATO!!!
    ignoraTimbratura: boolean,
    exportSoloSeM0: boolean,
    showFlagsWF: ShowFlagsWF,
    status: StatusGiustificativoRecord[],
    valMin: number, // float
    valMax: number, // float
    bgColor: string | null,
    /*
        stampaSuGiornale: boolean,
        stampaSuAllegato: boolean,
        tipoGiuMassa: 0 | 1 | 2, // GiustificativoRecord.Vedi elencoRegoleGiuMassa
        lungaAssenza?: number, // NON UTILIZZATO!!!
        codGiuLinked: string | null,
        conta: number,
    */
    aggancio: GiustificativoAggancioRecord | null,
}

/*
const a: GiustificativoRecord = {} as GiustificativoRecord;
a.showFlagsWF = ShowFlagsWF.planning | ShowFlagsWF.totali;
if ((a.showFlagsWF & ShowFlagsWF.planning) === ShowFlagsWF.planning) {
    console.log("mostra in planning!");
}
*/
export class GiustificativoRecord {

    public static readonly elencoTipo: TabellaGenerica[] = [
        {
            id: "O",
            descrizione: "Orario"
        },
        {
            id: "Q",
            descrizione: "Quantità"
        },
        {
            id: "I",
            descrizione: "Importo"
        },
        {
            id: "E",
            descrizione: "Evento"
        }
    ];
    public static readonly elencoTipoOre = [
        {
            id: "E",
            descrizione: "Eccedente diurno"
        },
        {
            id: "N",
            descrizione: "Eccedente notturno"
        },
        {
            id: "S",
            descrizione: "Supplementare diurno"
        },
        {
            id: "T",
            descrizione: "Supplementare notturno"
        },
        {
            id: "G",
            descrizione: "Maggiorazioni"
        },
        {
            id: "M",
            descrizione: "Mancanti"
        },
        {
            id: "X",
            descrizione: "Eccedente non straordinario"
        },
        {
            id: "Z",
            descrizione: "Evidenziato"
        },
        {
            id: "O",
            descrizione: "Ordinario diurno/notturno"
        }
    ];
    public static readonly elencoTipoAutomatismo = [
        {
            id: 0,
            descrizione: "Nessun automatismo"
        },
        {
            id: 3,
            descrizione: "Eccedente"
        },
        {
            id: 1,
            descrizione: "Eccedente ammesso"
        },
        {
            id: 7,
            descrizione: "Eccedente NON ammesso"
        },
        {
            id: 2,
            descrizione: "Compensazione"
        },
        {
            id: 5,
            descrizione: "Tolleranza"
        },
        {
            id: 6,
            descrizione: "Giustificativo automatico"
        }
    ];
    public static readonly elencoRegoleGiuMassa: TabellaGenerica[] = [
        {
            id: 0,
            descrizione: "Solo se previsto"
        },
        {
            id: 1,
            descrizione: "Sempre"
        },
        {
            id: 2,
            descrizione: "LUN-SAB"
        }
    ];

    // Costanti tipo giustificativo
    static readonly GiuOrario = "O";	// Orario
    static readonly GiuQuantita = "Q";	// Quantità
    static readonly GiuImporto = "I";	// Importo
    static readonly GiuEvento = "E";	// Evento

    // Costanti utili per la giustificazione di massa
    static readonly SoloPrevistoGDM = 0;	// Solo se previsto
    static readonly SempreGDM = 1;			// Tutti i giorni
    static readonly LunSabGDM = 2;			// LU-SA

    static factory: ObjectFactory<GiustificativoRecord> = (json?) => {
        return merge<GiustificativoRecord, Partial<GiustificativoRecord> | undefined>({
            idAzienda: null,
            codGiu: null,
            descrizione: null,
            tipoAutomatismo: null,
            tipoGiu: null,
            tipoOreGiu: null,

            applicaSu6: false,
            applicaSu7: false,
            applicaSuAltri: false,
            applicaSuFS: false,

            mancanteLavorato: false,
            stampaMancanteLavorato: false,
            decimaleMin: 0,
            decimaleMultipliDi: 0,
            idProfiloGiu: null,
            consenti0sePrev0: false,
            convertiQinHH: false,
            eccedenteRetribuito: false,
            specificaValore: false,
            idGruppoValori: null,
            tipoCalcoloConvenzionale: undefined, // NON UTILIZZATO!!!
            ignoraTimbratura: false,
            exportSoloSeM0: false,
            showFlagsWF: 0,
            status: [],
            insertTrace: undefined,
            lastUpdateTrace: undefined,
            valMin: 0,
            valMax: 0,
            stampaSuGiornale: false,
            stampaSuAllegato: false,
            tipoGiuMassa: 0,
            lungaAssenza: undefined,
            codGiuLinked: null,
            bgColor: null,
            conta: 0,
            usaInPianificazione: false,
            URI: null,
            aggancio: null,
        }, json);
    };

    static getInstance = (): GiustificativoRecord => {
        return GiustificativoRecord.factory();
    };

    static getTipoGiu = (giu: GiustificativoRecord): TipoGiustificativo | undefined => {
        switch (giu.tipoGiu) {
            case GiustificativoRecord.GiuOrario:
                return "ORARIO";
            case   GiustificativoRecord.GiuQuantita:
                return "QUANTITA";
            case   GiustificativoRecord.GiuImporto:
                return "IMPORTO";
            case   GiustificativoRecord.GiuEvento:
                return "EVENTO";
            default:
                return undefined;
        }
    };

    static getBgColor = function (giu: GiustificativoRecord | null, defaultBgColor: string | undefined = "#ffff00") {
        if (giu) {
            if (giu.bgColor === null || giu.bgColor.trim() === "") {
                return defaultBgColor;
            } else {
                return giu.bgColor;
            }
        }
    };

    static isMancante = function (giu: GiustificativoRecord | undefined) {
        if (!giu) return false;
        return (giu.tipoGiu === GiustificativoRecord.GiuOrario && giu.tipoOreGiu === "M");
    };

    static isEccedente = function (giu: GiustificativoRecord | undefined) {
        if (!giu) return false;
        /*
        E Eccedenti straordinarie diurne
        N Eccedenti straordinarie notturne
        S Supplementari diurne
        T Supplementari notturne
        G Maggiorazione
        M Mancanti
        X Eccedenti non straordinarie
        Z Evidenziate
        O Ordinarie diurne/notturne
         */
        //const giuEccedenti = 'ENST'; fino al 5/10/2021
        const giuEccedenti = "ENSTX";
        return (giu.tipoGiu === GiustificativoRecord.GiuOrario && giuEccedenti.indexOf(giu.tipoOreGiu || "?") !== -1);
    };
    static isAutomatico = function (giu: GiustificativoRecord) {
        return (giu.tipoAutomatismo === 6); // automatico
    };

    static isTolleranza = function (giu: GiustificativoRecord) {
        return (giu.tipoAutomatismo === 5); // tolleranza
    };

    static isAutomaticoEccA = function (giu: GiustificativoRecord) {
        return ((giu.tipoAutomatismo === 1) || (giu.tipoAutomatismo === 3));
    };
    static isAutomaticoEccNA = function (giu: GiustificativoRecord) {
        return ((giu.tipoAutomatismo === 7) || (giu.tipoAutomatismo === 3));
    };
    static isAutomaticoComp = function (giu: GiustificativoRecord) {
        return (giu.tipoAutomatismo === 2);
    };

    static hasStatus = (that: GiustificativoRecord, elencoStatus: LavoratoreStatusRecord[]) => {
        let addGiu = (that.status.length === 0);
        if (!addGiu && elencoStatus && elencoStatus.length) {
            for (let indStatus = 0; !addGiu && indStatus < that.status.length; ++indStatus) {
                const codStatus = that.status[indStatus].id;
                for (let indFiltroStatus = 0; indFiltroStatus < elencoStatus.length; ++indFiltroStatus) {
                    if (elencoStatus[indFiltroStatus].codice === codStatus) {
                        addGiu = true;
                    }
                }
            }
        }
        return addGiu;

    };
    static isGMCompliance = function (that: GiustificativoRecord, day: PresenzeGiornataPlusRecord) {
        if (that.tipoGiuMassa === GiustificativoRecord.SoloPrevistoGDM) // Solo se previsto
        {
            return (day.totali !== null && (day.totali.hPrevDiurne + day.totali.hPrevNotturne) > 0);
        } else if (that.tipoGiuMassa === GiustificativoRecord.SempreGDM) {
            return true;
        } else if (that.tipoGiuMassa === GiustificativoRecord.LunSabGDM) {
            return day.idGiorno !== 7;
        }
    };

    static isDayCompliance = function (giu: GiustificativoRecord, day: PresenzeGiornataPlusRecord) {
        const applicaSu6 = (giu.applicaSu6 && (day.festivo ? false : day.giorno6)); // Modifica del 23/07/2021, se festivo su sabato allora NON considero la giornata come sabato
        const applicaSu7 = (giu.applicaSu7 && (day.festivo ? false : day.giorno7)); // Modifica del 23/07/2021, se festivo su domenica allora NON considero la giornata come domenica
        const applicaSuFS = (giu.applicaSuFS && day.festivo);
        const applicaSuAltri = (giu.applicaSuAltri && !(day.giorno6 || day.giorno7 || day.festivo));

        return (applicaSu6 || applicaSu7 || applicaSuFS || applicaSuAltri);
    };

    static isOrario = function (giu: GiustificativoRecord) {
        return giu.tipoGiu === GiustificativoRecord.GiuOrario;
    };
    static isEvento = function (giu: GiustificativoRecord) {
        return (giu.tipoGiu === GiustificativoRecord.GiuEvento);
    };
    static normalize = function (giu: GiustificativoRecord) {
        if (!GiustificativoRecord.isOrario(giu)) {
            giu.tipoOreGiu = null;
        }
        if (!GiustificativoRecord.isEvento(giu)) {
            giu.idGruppoValori = null;
        }
    };

    static hasRange = (giu: GiustificativoRecord) => {
        return !((giu.valMin === giu.valMax) && giu.valMax === 0);
    };

    static hasFixedVal = (giu: GiustificativoRecord) => {
        if (!GiustificativoRecord.isOrario(giu)) {
            if (GiustificativoRecord.hasRange(giu)) {
                if (giu.valMin === giu.valMax) {
                    return true;
                }
            }
        }
        return false;
    };

    /**
     * Metodo per la validazione della quantità di un giustificativo
     * @param nGiu quantità espressa in minuti!
     * @param nPrevisto previsto espresso in minuti!
     * @param modSTD boolean true->gestione std ante 2021, false plus e std 2021
     * @returns {boolean}
     */
    static isRangeValid = (giu: GiustificativoRecord, nGiu: number, nPrevisto: number, modSTD: boolean): boolean => {
        if (!GiustificativoRecord.hasRange(giu)) {
            return true;
        } else {
            const isOrario = GiustificativoRecord.isOrario(giu);
            const divisore = isOrario ? 60 : 1;
            const nGiuMinuti = nGiu;
            let valid;
            if (modSTD !== true) { // N.B. per modSTD si intende la "vecchia" mod. standard, dalla versione 2021 le 2 gestioni sono uniformate!
                nGiu /= divisore;
            }

            // Verifico range valore (parte intera e decimale), tutto in centesimi
            if (giu.valMax === 0) {
                valid = (nGiu >= giu.valMin);
            } else {
                valid = (nGiu >= giu.valMin) && (nGiu <= giu.valMax);
            }

            // Verifico se è ammesso un valore a zero per giornate senza previsto (es. malattia)
            if (!valid && giu.consenti0sePrev0) {
                valid = ((nGiu === 0) && (nPrevisto === 0));
            }

            // Verifico parte decimale
            if (valid) {
                let decimali;
                if (isOrario) {
                    decimali = nGiuMinuti % 60; // se giustificativo orario, la quantità frazionaria viene calcolata in minuti!
                } else {
                    const interi = (nGiu - nGiu % 1); // parte intera in ore (se giu orario)
                    decimali = nGiu - interi;
                    decimali = decimali * 100;
                    decimali = decimali - decimali % 1;
                }
                if (decimali > 0) { // se ho una parte frazionaria...
                    const minimo = giu.decimaleMin; // N.B. se giustificativo orario la quantità minima è gia espressa in minuti
                    valid = (minimo === 0 || decimali >= minimo);
                    if (valid) {
                        if (giu.decimaleMultipliDi > 0) {
                            const multipli = giu.decimaleMultipliDi; // N.B. se giustificativo orario la quantità multipliDi è gia espressa in minuti
                            valid = (decimali % multipli) === 0;
                        }
                    }
                }
            }
            return valid;
        }
    };

    static getRangeText2021 = (giu: GiustificativoRecord): string => {
        if (giu) {
            if (GiustificativoRecord.hasRange(giu)) {
                const unitaDiMisura = GiustificativoRecord.isOrario(giu) ? "ore" : "";
                let str;
                if (giu.valMax === 0) {
                    str = `Valore min.: ${giu.valMin} ${unitaDiMisura}`;
                } else {
                    str = `Valore min.: ${giu.valMin} ${unitaDiMisura} valore max: ${giu.valMax} ${unitaDiMisura}`;
                }

                if ((giu.decimaleMin > 0) || (giu.decimaleMultipliDi > 0)) {
                    const unitaDiMisura = GiustificativoRecord.isOrario(giu) ? "minuti" : "cent.";
                    str = str + ` - parte frazionaria: min. ${giu.decimaleMin} ${unitaDiMisura}`;
                    if (giu.decimaleMultipliDi > 0) {
                        str = str + ` e multipli di ${giu.decimaleMultipliDi} ${unitaDiMisura}`;
                    }
                }

                return str;
            }
            return "Nessun range...";
        }
        return "";
    };

    /**
     * adegua la quantità indicata (in hh,cc) ai valori minimi e massimi, nonché adegua la parte decimale al valore minimo e multiplo
     * @param that
     * @param quantita
     * @returns {*}
     */
    static ageduaQuantitaOraria = (that: GiustificativoRecord, quantita: number) => {
        if (that.valMin > 0) {
            quantita = (quantita < that.valMin) ? that.valMin : quantita;
        }
        if (that.valMax > 0) {
            quantita = (quantita > that.valMax) ? that.valMax : quantita;
        }
        if (that.decimaleMin || that.decimaleMultipliDi) {
            const parteIntera = Math.floor(quantita);
            let decimali = (quantita * 60) % 60;
            if (decimali > 0) {
                if (that.decimaleMin > 0) {
                    decimali = (decimali < that.decimaleMin) ? that.decimaleMin : decimali;
                }
                if (that.decimaleMultipliDi > 0) {
                    const resto = decimali % that.decimaleMultipliDi;
                    if (resto !== 0) {
                        decimali = decimali + that.decimaleMultipliDi;
                        decimali = Math.floor(decimali / that.decimaleMultipliDi) * that.decimaleMultipliDi;
                    }
                }
            }
            quantita = (parteIntera * 60 + decimali) / 60;
        }
        return quantita;
    };
}